/**
 * Every text area in the app (chauffeur notes, comments, messages, reasons)
 * shows this many lines and scrolls past them. The height comes from `rows`
 * alone: the global rule in styles/yeloplus-tokens.scss removes the resize
 * handle and the per-page min-heights, so the box is the same four lines at
 * whatever font and padding each field uses.
 */
export const TEXTAREA_ROWS = 4;
